import React from "react";

import { Pagination } from "antd";

export interface PaginationControlsProps {
  className?: string;
  current: number;
  onChange?: (page?: number, pageSize?: number) => void;
  size?: string | "small";
  total: number;
  pageSize?: number;
  "data-testid"?: string;
  itemLabel?: string;
  showTotal?: boolean | ((total: number, range: [number, number]) => string);
}

const PaginationControls = ({
  current,
  total,
  pageSize = 10,
  onChange = undefined,
  className = undefined,
  size = undefined,
  "data-testid": dataTestId = "pagination-controls",
  itemLabel = "items",
  showTotal = true,
}: PaginationControlsProps) => {
  // Calculate total pages and ensure valid pagination state
  const totalPages = Math.ceil(total / pageSize);
  const safeCurrent = Math.min(Math.max(1, current), Math.max(1, totalPages));
  const showPagination = total > pageSize || current > 1;

  // Don't render if no pagination needed
  if (!showPagination) {
    return null;
  }

  // Configure showTotal based on props
  const showTotalConfig =
    showTotal === false
      ? undefined
      : typeof showTotal === "function"
      ? showTotal
      : (total: number, range: [number, number]) =>
          `${range[0]}-${range[1]} of ${total} ${itemLabel}`;

  return (
    <Pagination
      current={safeCurrent}
      total={total}
      pageSize={pageSize}
      onChange={onChange}
      className={className}
      size={size}
      data-testid={dataTestId}
      showSizeChanger={false}
      showQuickJumper={false}
      showTotal={showTotalConfig}
      hideOnSinglePage={false}
    />
  );
};

export default PaginationControls;
